import React from 'react';

const WCPlaceholder = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={108} height={54} fill="none" {...props}>
    <mask id="a" fill="#fff">
      <path d="M43 22c0 .552-.463 1.015-.976.81a2.976 2.976 0 0 1-1.145-.835C40.316 21.318 40 20.428 40 19.5c0-.928.316-1.819.879-2.475.325-.38.718-.663 1.145-.835.513-.205.976.258.976.81v5Z" />
    </mask>
    <path
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={2}
      d="M43 22c0 .552-.463 1.015-.976.81a2.976 2.976 0 0 1-1.145-.835C40.316 21.318 40 20.428 40 19.5c0-.928.316-1.819.879-2.475.325-.38.718-.663 1.145-.835.513-.205.976.258.976.81v5Z"
      mask="url(#a)"
    />
    <mask id="b" fill="#fff">
      <path d="M53 22c0 .552.463 1.015.976.81.427-.172.82-.455 1.145-.835.563-.657.879-1.547.879-2.475 0-.928-.316-1.819-.879-2.475a2.976 2.976 0 0 0-1.145-.835c-.513-.205-.976.258-.976.81v5Z" />
    </mask>
    <path
      fill="#D9D9D9"
      stroke="#959595"
      strokeWidth={2}
      d="M53 22c0 .552.463 1.015.976.81.427-.172.82-.455 1.145-.835.563-.657.879-1.547.879-2.475 0-.928-.316-1.819-.879-2.475a2.976 2.976 0 0 0-1.145-.835c-.513-.205-.976.258-.976.81v5Z"
      mask="url(#b)"
    />
    <path
      fill="#E9E9E9"
      stroke="#959595"
      d="m49.266 26.15.2.459-.2-.459-1.218.533-.67-.44a1 1 0 0 0-1.014-.049l-1.864.979V16.5h7v10.574l-1.285-.843a1 1 0 0 0-.95-.08Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M1 53h106"
    />
    <path fill="#F3F3F3" stroke="#AAA" strokeWidth={2} d="M63 2h25v29H63V2Z" />
    <path fill="#959595" stroke="#B3B3B3" strokeWidth={2} d="M63 30h23v1H63v-1Z" opacity={0.52} />
    <path fill="#959595" stroke="#E4E4E4" strokeWidth={2} d="M63 2h23v1H63V2Z" opacity={0.48} />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M59 32h33M62.767 1h25.466v31H62.767V1Z"
    />
    <path
      stroke="#C4C4C4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.6}
      d="m67 15.311 6.52-6.98m1.604 4.96L81 7M68.856 20l4.094-4.382"
    />
    <path
      fill="#959595"
      stroke="#959595"
      d="M15.4 20.24c0-1.004-.736-1.74-1.74-1.74-.981 0-1.74.873-1.74 1.74 0 1.004.736 1.74 1.74 1.74s1.74-.736 1.74-1.74Zm-.12 0c0 .916-.704 1.62-1.62 1.62-.916 0-1.62-.704-1.62-1.62 0-.916.704-1.62 1.62-1.62.916 0 1.62.704 1.62 1.62Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.6 32.1h17.356c2.784 0 4.177 0 5.016 1.396.84 1.399.346 2.288-.645 4.07A11.59 11.59 0 0 1 29.17 43.5M17.6 32.1V18.8c0-1.792 0-2.687-.557-3.243C16.487 15 15.592 15 13.8 15c-1.792 0-2.687 0-3.243.557C10 16.113 10 17.008 10 18.8v13.3c0 1.792 0 2.687.557 3.243.556.557 1.451.557 3.243.557 1.792 0 2.687 0 3.243-.557.557-.556.557-1.451.557-3.243Z"
    />
    <path
      stroke="#959595"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M33 43c-1.9 1.9-.2 8.1 3.6 10H10c1.9-1.9 5.13-7.98 2.85-17.1"
    />
    <path
      stroke="#C8C8C8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M27 45c-.5 2 .571 3.778 3 5H15.5c1.214-1.222 2.207-5.522.75-11.389"
    />
    <path stroke="#959595" strokeWidth={1.6} d="M17 35.2h23" />
  </svg>
);

export default WCPlaceholder;
